export const state = {
  department: [],
};
